import { useState } from 'react';

export default function StatsSection() {
  const [activeIndex, setActiveIndex] = useState(0);

  const stats = [
    { label: '累计用户', value: '500,000+', icon: 'ri-user-line', suffix: '人' },
    { label: '每日赛事', value: '500+', icon: 'ri-trophy-line', suffix: '场' },
    { label: '合作联赛', value: '80+', icon: 'ri-global-line', suffix: '个' },
    { label: '分析文章', value: '5,000+', icon: 'ri-article-line', suffix: '篇' },
  ];

  return (
    <section className="bg-background-950 py-12 md:py-16">
      <div className="max-w-[1400px] mx-auto px-4 md:px-6">
        <div className="text-center mb-10">
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-white">
            好博体育 · 值得信赖的体育竞技平台
          </h2>
          <p className="text-sm text-foreground-300 mt-2">
            以安全、公正、便捷为核心，为广大体育爱好者打造极致体验
          </p>
        </div>

        <div className="grid grid-cols-2 lg:grid-cols-4 gap-6">
          {stats.map((stat, index) => (
            <div
              key={stat.label}
              className="text-center group cursor-pointer"
              onMouseEnter={() => setActiveIndex(index)}
            >
              <div
                className={`w-16 h-16 flex items-center justify-center mx-auto mb-4 rounded-2xl transition-all duration-300 ${
                  activeIndex === index
                    ? 'bg-accent-500 text-foreground-950 scale-110'
                    : 'bg-foreground-800 text-accent-400'
                }`}
              >
                <i className={`${stat.icon} text-2xl`}></i>
              </div>
              <div
                className={`font-heading text-3xl md:text-4xl font-bold mb-1 transition-colors duration-300 ${
                  activeIndex === index ? 'text-accent-400' : 'text-white'
                }`}
              >
                {stat.value}
              </div>
              <div className="text-sm text-foreground-400">
                {stat.label}
              </div>
            </div>
          ))}
        </div>

        <div className="mt-12 grid grid-cols-1 md:grid-cols-3 gap-6">
          {[
            { icon: 'ri-shield-check-line', title: '安全可靠', desc: '多重加密技术保障用户数据安全，严格的风控体系确保平台公正' },
            { icon: 'ri-flashlight-line', title: '极速体验', desc: '毫秒级数据更新，流畅的直播体验，让您不错过任何精彩瞬间' },
            { icon: 'ri-customer-service-2-line', title: '专业服务', desc: '7×24小时客服支持，专业分析师团队提供深度赛事解读' },
          ].map((item) => (
            <div
              key={item.title}
              className="flex items-start gap-4 p-5 rounded-xl bg-foreground-800/50 border border-foreground-700/30"
            >
              <div className="w-10 h-10 flex items-center justify-center rounded-lg bg-accent-500/20 flex-shrink-0">
                <i className={`${item.icon} text-lg text-accent-400`}></i>
              </div>
              <div>
                <h3 className="font-heading text-base font-semibold text-white mb-1">{item.title}</h3>
                <p className="text-sm text-foreground-300 leading-relaxed">{item.desc}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}